import { writable } from "svelte/store";

export const poorcatsnftcontract = writable({})

export const transactionStatus = writable('none')
export const modalText = writable('')
export const blocked = writable(false)